<script>
  export let text;
  export let link;
</script>

<a href={link}><button>{text}</button></a>

<style>
  button {
    font-weight: bold;
    font-size: 16px;
    background-color: #fff;
    color: black;
    text-decoration: none;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    text-transform: uppercase;
    transition: 0.3s ease;
  }

  button:hover {
    scale: 1.17;
  }

  /* Media query for screens that are 768px wide or smaller */
  @media (max-width: 768px) {
    button {
      padding: 5px 10px; /* Half of the original padding */
      font-size: 50%; /* Adjust font size */
      border-radius: 2.5px; /* Half of the original border-radius */
      /* Add other properties to adjust sizes here */
    }
  }
</style>
